module.exports = __webpack_public_path__ + "static/cause-1-1-b7e36f97adb643d9c89cd6901d194293.jpg";